<template lang="pug">
marquee#marquee.marquee.news_ticker(v-if="isMobile", scrollamount="5")
  .marqueeSpanBox
    li.run(v-for="(marquee, index) in messageList", :key="index") 
      span
      p(
        @click="openUrl(marquee.URL)",
        :style="[marquee.URL && marquee.URL != '' ? { cursor: 'pointer' } : {}]"
      ) {{ marquee.Title }}
marquee#marquee.marquee.news_ticker(
  v-else="",
  scrollamount="5",
  @mouseover="marqueeMove()",
  @mouseleave="marqueeOut()"
)
  .marqueeSpanBox
    li.run(v-for="(marquee, index) in messageList", :key="index") 
      span
      p(
        @click="openUrl(marquee.URL)",
        :style="[marquee.URL && marquee.URL != '' ? { cursor: 'pointer' } : {}]"
      ) {{ marquee.Title }}
</template>

<script>
export default {
  name: "NewsTicker",
  props: {
    messageList: Array,
  },
  data() {
    return {
      cssRule: null,
      count: 0,
      currentMessageData: {
        Title: "",
        URL: "",
      },
    };
  },
  computed: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag != null ? true : false;
    },
  },
  methods: {
    marqueeMove() {
      var marquee = document.getElementById("marquee");
      marquee.stop();
    },
    marqueeOut() {
      var marquee = document.getElementById("marquee");
      marquee.start();
    },
    openUrl(url) {
      if (url && url != "") {
        window.open(url);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/news_ticker";
</style>
